(() => {
  const mounted = new WeakMap();
  function mount(scope = document) {
    scope.querySelectorAll('[data-kinora-activities]').forEach(root => {
      mounted.get(root)?.();
      const frames = [...root.querySelectorAll('[data-activity-frame]')];
      const media = matchMedia('(prefers-reduced-motion: reduce)');
      const abort = new AbortController();
      let current = 0, timer = 0, visible = false, generation = 0, disposed = false;
      const pending = new WeakMap();
      const hydrate = frame => {
        const img = frame.querySelector('img');
        if (pending.has(img)) return pending.get(img);
        if (img.dataset.src) {
          img.srcset = img.dataset.srcset || '';
          img.src = img.dataset.src;
          delete img.dataset.src;
          delete img.dataset.srcset;
        }
        const promise = img.decode().then(() => img.naturalWidth > 0).catch(() => false);
        pending.set(img, promise);
        return promise;
      };
      const allowed = () => !disposed && visible && !document.hidden && !media.matches;
      function stop() { clearTimeout(timer); timer = 0; generation++; }
      function schedule() {
        if (!allowed() || timer || frames.length < 2) return;
        const next = (current + 1) % frames.length;
        const ready = hydrate(frames[next]);
        const token = generation;
        timer = setTimeout(async () => {
          timer = 0;
          const loaded = await ready;
          if (token !== generation || !allowed()) return;
          if (loaded) {
            frames[current].classList.remove('is-active');
            frames[current].setAttribute('aria-hidden', 'true');
            frames[next].classList.add('is-active');
            frames[next].setAttribute('aria-hidden', 'false');
            current = next;
            root.dataset.activityIndex = String(current);
          }
          schedule();
        }, Number(root.dataset.interval) || 2000);
      }
      function sync() { stop(); schedule(); }
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        sync();
      }, { threshold: .12 }) : null;
      if (observer) observer.observe(root); else { visible = true; schedule(); }
      document.addEventListener('visibilitychange', sync, { signal: abort.signal });
      media.addEventListener('change', sync, { signal: abort.signal });
      const cleanup = () => { disposed = true; stop(); observer?.disconnect(); abort.abort(); };
      mounted.set(root, cleanup);
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload', cleanup, { once: true, signal: abort.signal });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true }); else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
